var FcOutlinedSelectModule = /** @class */ (function () {
    function FcOutlinedSelectModule() {
    }
    return FcOutlinedSelectModule;
}());
export { FcOutlinedSelectModule };
